/**
 * Takes a formik form object and checks
 * if any of the form fields has been touched
 *
 * @param {Object} formikFormObject - fromik object
 */
export const formHasBeenTouched = (formikFormObject) =>
  typeof formikFormObject === 'object' &&
  formikFormObject.touched &&
  typeof formikFormObject.touched === 'object' &&
  Object.values(formikFormObject.touched).length;
